import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  deleteTextThunk,
  getTextPaginateThunk,
  validateTextThunk,
} from './textThunk';

const defaultPage = {
  docs: [],
  hasMore: false,
  hasNextPage: false,
  hasPrevPage: false,
  limit: 12,
  page: 1,
  pagingCounter: 1,
  totalDocs: 1,
  totalPages: 1,
};

const initialState = {
  isLoading: false,
  draft: { title: '', text: '' },
  paginate: { ...defaultPage },
};

export const getTextPaginate = createAsyncThunk(
  'text/paginate',
  getTextPaginateThunk
);

export const deleteText = createAsyncThunk('text/delete', deleteTextThunk);
export const validateText = createAsyncThunk(
  'text/validate',
  validateTextThunk
);

const textSlice = createSlice({
  name: 'text',
  initialState,
  reducers: {
    setPage: (state, { payload }) => {
      state.paginate.page = payload.page;
    },
  },
  extraReducers: {
    [getTextPaginate.pending]: (state) => {
      state.isLoading = true;
    },
    [getTextPaginate.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.paginate = payload;
    },
    [getTextPaginate.rejected]: (state) => {
      state.isLoading = false;
      state.paginate = { ...defaultPage };
    },
    [deleteText.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteText.fulfilled]: (state, { payload }) => {
      const { id } = payload;
      state.isLoading = false;
      state.paginate.docs = state.paginate.docs.filter(
        (item) => item._id !== id
      );
    },
    [deleteText.rejected]: (state) => {
      state.isLoading = false;
    },
    [validateText.pending]: (state) => {
      state.isLoading = true;
    },
    [validateText.fulfilled]: (state, { payload }) => {
      const { text, valid, fixed } = payload;
      state.isLoading = false;
      console.log(text, valid, fixed);
    },
    [validateText.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { setPage } = textSlice.actions;
export default textSlice.reducer;
